import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ToastsManager} from 'ng2-toastr/ng2-toastr'
import {AuthService} from './services/auth.service';
import {Router} from '@angular/router';
import {CertificatesService} from './services/certificates.service';

import {environment} from '../environments/environment';
import {ClockService} from './services/clock.service';
import {Subscription} from 'rxjs/Subscription';
import * as moment from 'moment-timezone';
import {DateFieldHelper} from './document/date-field-helper';
import {TimerObservable} from 'rxjs/observable/TimerObservable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ClockService]
})
export class AppComponent implements OnInit {
  public regExternalLink = /^(https?:)?\/\//;
  public auth_url: string = environment.auth_url;
  public home_url: string = environment.home_url;
  public isMenuLoaded = false;
  private logout_timer_subscription: Subscription;

  public username: string;
  public organization: string;
  public isLogging: boolean;

  public currentYear: number;

  // time options
  public dateTime;
  public dateTimeUser;
  public timeZone;
  private now;
  private updatePeriod;
  private currentPeriod = 0;
  private interval = 0;

  public authReady = false;

  public constructor(
    private auth: AuthService, private router: Router,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private certService: CertificatesService,
    private view_container: ViewContainerRef,
    private service: AuthService,
    private clockService: ClockService,
  ) {
    this.toastr.setRootViewContainerRef(view_container);
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    // run clock
    this.runClock();

    const token = this.auth.get_token();
    const cross_token = this.auth.get_cross_token();

    // если включен режим удалённой аутентификации
    if (environment.remote_auth_mode) {
      this.makeCrossAuth(token, cross_token);
    } else {
      this.authReady = true;
    }
  }

  private makeCrossAuth(token: string, cross_token: string): void {
    if (
      (cross_token && !token)
      || (cross_token && token && !this.auth.check_tokens())
    ) {
      // если присутствует токен сквозной авторизации и ещё отсутсвует токен вторизации системы:
      // выполняем сковзную авторизацию
      this.auth.local_logout();
      this.auth.make_cross_log_in(cross_token).toPromise().then(
        data => {
          if (data && data['access_token']) {
            this.auth.set_token(data['access_token']);
            this.auth.set_check_token(cross_token);
            this.certService.setCertsList(data['certificateSN'], data['issuerDN']);
            this.authReady = true;
            // this.router.navigateByUrl('/');
          }
        },
        error => {
          this.authReady = true;
          console.log(error.message);
        }
      );
    } else if (!cross_token && token) {
      // если отсутствует токен сквозной авторизации, но мы авторизованы в нашей системе - удаляем токен аутентификации
      this.auth.logout();
      this.authReady = true;
      // this.router.navigateByUrl('/');
    } else {
      this.authReady = true;
    }
  }

  runClock() {

    this.getServerTime();

    clearInterval(this.interval);
    this.interval = setInterval(
      () => this.setTime(),
      1000
    );
  }

  setTime() {

    ++this.currentPeriod;
    if (this.updatePeriod === this.currentPeriod) {
      this.getServerTime();
      this.currentPeriod = 0;
    }

    this.now = moment(this.now, 'YYYY-MM-DD HH:mm:ss').add(1, 'second').format();
    const time = moment(this.now);
    this.dateTime = time.format('DD.MM.YYYY HH:mm:ss');
    // time.utcOffset(environment.timezoneUser).format('DD.MM.YYYY H:mm:ss') + ' (MSK' + environment.timezoneUserOffsetMsk + ')';
    this.dateTimeUser = new DateFieldHelper().transformDatetimeValue(this.now);

  }

  getServerTime() {
    this.clockService.getTime().subscribe(date => {

      this.now = date['dateTime'];
      this.updatePeriod = date['updatePeriod'];

      //   moment.tz.add(this.clockService.getTimezone());
      this.timeZone = '(MSK' + environment.timezoneDefaultOffsetMsk + ')'; // moment().tz(date['timeZone']).format('(zZ)');
    });
  }

  logout() {
    this.auth.logout();
    this.username = '';
    if (this.regExternalLink.test(environment.logout_url)) {
      window.location.href = environment.logout_url;
    } else {
      this.router.navigateByUrl(environment.logout_url);
    }
    return false;
  }

  afterLoadedMenu(info: { isMenuLoaded: boolean }) {
    const self = this;
    if (info.isMenuLoaded) {
      if (this.isLogging) {
        this.service.get_user_data().subscribe(
          data => {
            environment.timezoneUser = data['timezoneUser'];
            environment.timezoneUserOffsetMsk = data['timezoneUserOffsetMsk'];
            self.isMenuLoaded = info.isMenuLoaded;
          },
          error => {
            self.isMenuLoaded = info.isMenuLoaded;
            console.log(error.message);
          });
      } else {
        environment.timezoneUser = environment.timezoneDefault;
        environment.timezoneUserOffsetMsk = environment.timezoneDefaultOffsetMsk;
        self.isMenuLoaded = info.isMenuLoaded;
      }
    } else {
      self.isMenuLoaded = info.isMenuLoaded;
    }
  }

  isLoging() {
    if (!this.isLogging && this.isLogging !== this.service.isLogin()) {
      this.getUsername();
    }
    this.isLogging = this.service.isLogin();
    return this.isLogging;
  }

  getUsername() {
    this.service.get_user_data().subscribe(
      data => {
        this.username = data['username'];
        this.organization = data['organization'];
      },
      error => {
        console.log(error.message);
      });

  }

  private set_logout_timer() {
    if (this.logout_timer_subscription !== undefined) {
      this.logout_timer_subscription.unsubscribe();
    }
    this.logout_timer_subscription = TimerObservable
      .create(environment.logoutAfter * 1000)
      .subscribe(data => {
        this.logout_timer_subscription.unsubscribe();
        this.auth.logout();
        this.auth.inactivity_logout = true;
        this.toastr.warning(
          'Ваша сессия закрыта по причине бездействия',
          'Внимание',
          {dismiss: 'click'}
        );
      });
  }

  private addZero(num) {
    return ('0' + num).substr(-2);
  }

  public is_home_url_absolute() {
    return this.home_url.indexOf('http://') === 0 || this.home_url.indexOf('https://') === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts